import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams
} from "react-router-dom"
import { GlobalContext } from '../GlobalContext'
import { subscribe } from '../utils/pubsub'
import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import Modal from '../ui-elements/Modal'
import Spinner from '../ui-elements/Spinner'
import YellowAlert from '../ui-elements/YellowAlert'
import { startNewQuestion } from './checklist-utils/startNewQuestion'


type Props = {
    checklistId: string
}

function ResultsOptions({
    checklistId
}: Props) {

    const {
        tableData,
        sendMessageToWebsocket,
        setChecklistQuestionFields
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const checklistQuestions = tableData && checklistId && tableData.ChecklistQuestions && Object.keys(tableData.ChecklistQuestions).filter((questionKey) => tableData.ChecklistQuestions[questionKey].ChecklistId === checklistId && !tableData.ChecklistQuestions[questionKey].isDeleted)
    const thisYear = new Date().getFullYear()
    const thisMonth = new Date().getMonth() + 1 // Months are 0
    const thisDay = new Date().getDate()



    return <Card fullwidth={true}>
        <div className={`w-full h-full flex flex-col gap-4 justify-between`}>
            <div className={`flex-1 flex flex-col gap-2`}>
                <h4 className={`font-righteous text-xl font-brandblue`}>Results</h4>
            </div>

            <div className={`flex flex-col gap-2`}>
                <Button
                    internalLinkUrl={`/checklists/${checklistId}/results/${thisYear}/${thisMonth}/${thisDay}`}
                    text={`Results by day`}
                    variant='primary'
                    fullwidth={true}
                />
                <Button
                    internalLinkUrl={`/checklists/${checklistId}/results/${thisYear}/${thisMonth}/`}
                    text={`Results by month`}
                    variant='primary'
                    fullwidth={true}
                />
                <Button
                    internalLinkUrl={`/checklists/${checklistId}/export-results/`}
                    text={`Export results`}
                    variant='primary'
                    fullwidth={true}
                />
            </div>

        </div>
    </Card>
}
export default ResultsOptions